'use client'

import * as React from 'react'
import { Drawer as DrawerPrimitive } from 'vaul'

import {
  Drawer,
  DrawerClose,
  DrawerContent as OriginDrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from '../ui/drawer'
import { cn } from '../../lib/utils'

const DrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <OriginDrawerContent
    style={{
      top: 'env(safe-area-inset-top, 0)',
      paddingBottom: 'env(safe-area-inset-bottom, 0)',
    }}
    className={cn('mt-0 rounded-none', className)}
    {...props}
  >
    {children}
  </OriginDrawerContent>
)) as React.ForwardRefExoticComponent<
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> &
    React.RefAttributes<React.ElementRef<typeof DrawerPrimitive.Content>>
>
DrawerContent.displayName = 'DrawerContent'

export {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
}
